export class LoadOMatic {
	constructor( options ) {
		this.current_page = options.currentPage || 1;
		this.total_pages = options.totalPages;
		this.load_url = options.loadUrl;
		this.extra_query = options.extraQuery || '';
		this.next_page = this.current_page + 1;
		this.handle_trigger_dly = 0;

		this.append_container = document.querySelector( '.loadomatic' );
		this.message = document.querySelector( '.loadomatic__message' );
		this.trigger = document.querySelector( '.loadomatic__trigger' );

		this.callbacks = [];

		// initial load
		this.trigger.classList.add( 'loadomatic__trigger--disabled' );
		this.handleTrigger( 0 );

		this.trigger.addEventListener( 'click', ( event ) => {
			this.loadMore();
			event.preventDefault();
		} );
	}

	loadMore( replace_all = false, increment_page = true ) {
		if ( this.reached_end ) {
			return;
		}
		let url;
		if ( increment_page ) {
			url = this.getUrl( this.getCurrentPage() + 1 );
		} else {
			url = this.getUrl();
		}
		this.trigger.classList.add( 'loadomatic__trigger--hidden' );
		this.message.classList.remove( 'loadomatic__message--hidden' );
		ajax( {
			type: 'get',
			url: url,
			data: {},
			headers: [
				['X-LoadOMatic', 'yes'],
			],
			timeout: 5000,
			onSuccess: ( data, status ) => {
				if (
					data.trim() === ''
					|| ( replace_all === false && status === 202 )
				) {
					this.reached_end = true;
				} else {
					if ( replace_all ) {
						this.append_container.innerHTML = data;
					} else {
						this.append_container.innerHTML += data;
					}
					for ( let i = 0; i < this.callbacks.length; i++ ) {
						this.callbacks[i]();
					}
					if ( window.history.pushState ) {
						window.history.pushState( null, null, url );
					}
					this.current_page = this.current_page + 1;
				}
				this.handleTrigger();
			},
			onFailure: this.handleFailure(),
		} );
	}

	handleTrigger( delay ) {
		if ( this.reached_end || this.total_pages <= this.current_page ) {
			this.trigger.classList.add( 'loadomatic__trigger--hidden' );
			this.message.classList.add( 'loadomatic__message--hidden' );
			return;
		}
		this.trigger.classList.remove( 'loadomatic__trigger--hidden' );
		setTimeout( () => {
			this.trigger.classList.remove( 'loadomatic__trigger--disabled' );
		}, delay );
	}

	handleFailure() {
		return () => {
			this.message.classList.remove( 'loadomatic__message--hidden' );
			this.trigger.classList.add( 'loadomatic__trigger--hidden' );
			this.message.querySelector( 'p' ).innerHTML = 'Sorry, there was a problem retrieving content.';
		}
	}

	urlCreator( page, loadmore ) {
		// regex replaces should be dealt with before getting to this point, but just in case
		let extra_query = this.extra_query.replace( /&{0,1}page=\d+/, '' ).replace( /amp;/, '' );
		return ( this.load_url + '?' + ( extra_query.length ? extra_query + '&' : '' ) + 'page=' + page + ( loadmore ? '&loadmore=true' : '' ) );
	}

	getCurrentPage() {
		return parseInt(
			this.getQueryObject( window.location.search ).page || '1', 10
		);
	}

	getQueryObject( query_string ) {
		const query_object = {};
		const pairs = ( query_string[0] === '?' ? query_string.substr( 1 ) : query_string ).split( '&' );
		for ( let i = 0; i < pairs.length; i++ ) {
			const pair = pairs[i].split( '=' );
			if (pair != '' ) {
				let key = decodeURIComponent( pair[0] );
				const value = decodeURIComponent( pair[1] || '' );
				if ( key.substr( -2 ) === '[]' ) {
					key = key.substr( 0, key.length - 2 );
					if ( !( query_object[key] instanceof Array ) ) {
						query_object[key] = [];
					}
					query_object[key].push( value );
					continue;
				}
				query_object[key] = value;
			}
		}

		return query_object;
	}

	getQueryString( query_object ) {
		const query_pieces = [];
		for ( const key in query_object ) {
			if ( !query_object.hasOwnProperty( key ) ) {
				continue;
			}
			if ( query_object[key] instanceof Array ) {
				for ( let i = 0; i < query_object[key].length; i++ ) {
					query_pieces.push( key + '[]' + ( query_object[key][i] ? '=' + query_object[key][i] : '' ) );
				}
				continue;
			}
			query_pieces.push( key + ( query_object[key] ? '=' + query_object[key] : '' ) );
		}

		if ( query_pieces.length === 0 ) {
			return '';
		}
		if ( !query_pieces.includes( 'loadmore=1' ) ) {
			query_pieces.push(  'loadmore=1' );
		}
		return '?' + query_pieces.join( '&' );
	}

	getUrl( page = null ) {
		const query_object = this.getQueryObject( window.location.search );
		//if ( query_object.hasOwnProperty( 'page' ) ) {
		//	query_object.page = intval( query_object.page ) + 1;
		//}
		if ( page !== null ) {
			query_object.page = page;
		}
		const query_string = this.getQueryString( query_object );

		return `${window.location.pathname}${query_string}`;
	}

	addCallback( fx ) {
		this.callbacks.push( fx );
	}
}
